import { render, staticRenderFns } from "./collab_task_finish.vue?vue&type=template&id=fb49c65c&scoped=true"
import script from "./collab_task_finish.vue?vue&type=script&lang=js"
export * from "./collab_task_finish.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb49c65c",
  null
  
)

export default component.exports